<nav class="navbar navbar-expand-md navbar-light bg-light py-3" [ngClass]="stylingScheme">
  <a class="navbar-brand" href="#"><img></a>
  <h3 class="text-right">My Benefits</h3>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="nav navbar-nav ml-auto">
      <li class="nav-item px-2 text-right">
        <a class="nav-link text-primary" 
                [routerLink]="'/memberLogin'">Sign In</a>
      </li>
      <li class="nav-item">
        <button type="submit" class="btn rounded-pill border-dark float-right"
                [routerLink]="'/registration'">Create My Account</button>
      </li>
    </ul>
  </div>
</nav>
